import React, { Component } from "react";
import { CancellableDialog } from "components/dialogs";
import { FieldRow } from "components/forms";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

class CreateDialog extends Component {
  state = { datetime: "", message: "" };
  render() {
    const { onClose, onSubmit } = this.props;
    const { datetime, message } = this.state;
    return (
      <CancellableDialog
        isForm
        onClose={onClose}
        onSubmit={() => onSubmit(this.state)}
      >
        <h5>Add push notification</h5>
        <FieldRow>
          <span>Send time</span>
          <DatePicker
            showTimeSelect
            onChange={data => {

            this.setState({ datetime: data })}}
            selected={datetime}
            dateFormat="dd MMMM Y HH:mm"
            timeFormat="HH:mm"
            required
          />
        </FieldRow>
        <FieldRow>
          <span>Message</span>
          <textarea
            type="text"
            required
            value={ message }
            onChange={e => this.setState({ message: e.target.value })}
          >
          </textarea>
        </FieldRow>
      </CancellableDialog>
    );
  }
}

export default CreateDialog;
